import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [theme, setTheme] = useState(() => {
    // Check if a theme preference is stored in localStorage
    const savedTheme = localStorage.getItem('theme');
    // Check if user has a system preference
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    // Return saved theme or system preference or default to 'light'
    return savedTheme || (prefersDark ? 'dark' : 'light');
  });

  // Apply theme to document when theme changes
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  // Toggle between light and dark themes
  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  return (
    <div className="App">
      <header className="header">
        <img 
          src="/images/adam-sommer.jpg" 
          alt="Adam Sommer" 
          className="profile-image"
        />
        <div className="profile-info">
          <h1 className="name">ADAM SOMMER</h1>
          <p className="subtitle">Product @ Ramp</p>
          <p className="subtitle">New York, New York</p>
          <p className="subtitle">Duke University</p>
          
          <div className="company-icons">
            <div className="company-icon">
              <img src="/images/ramp_logo.png" alt="Ramp" />
            </div>
            <div className="company-icon">
              <img src="/images/yc_logo.png" alt="YC" />
            </div>
            <div className="company-icon" >
              <img src="/images/duke_logo.png" alt="Duke" style={{ backgroundColor: '#FFFFFF', padding: '15%' }}/>
            </div>
          </div>
        </div>
      </header>

      <section className="about-section">
        <h2 className="section-title">About Me</h2>
        <p>
          I've spent my career building and leading teams at startups and large technology companies. 
          I've built products from zero to one and developed platforms that process billions of dollars 
          every month.
        </p>
        <p style={{ marginTop: '1rem' }}>
          I am as enthusiastic about building strong teams as I am great products. I believe in
          speaking one's mind, being direct, doing high-leverage work, and challenging the status
          quo. 100x engineers do exist.
        </p>
      </section>

      <section>
        <h2 className="section-title">Experience</h2>
        
        <div className="experience-grid">
          <div className="experience-card">
            <div className="card-icon" style={{ backgroundColor: 'transparent' }}>
              <img src="/images/ramp_logo.png" alt="Ramp" />
            </div>
            <div className="card-content">
              <h3 className="card-title">Director of Product</h3>
              <p className="card-description">
                <span className="company-name">Ramp</span>
                <span className="location-date">New York, NY · Sep 2023 - Present</span>
              </p>
              <p className="card-summary">
                Building Ramp's money platform -- cards, payments, accounts, wallets, crypto -- and leading our international expansion efforts. Learning about fintech and what it takes to build and scale at hyper-velocity.
              </p>
            </div>
          </div>

          <div className="experience-card">
            <div className="card-icon">
              <img src="/images/kable_logo.png" alt="Kable" style={{ backgroundColor: '#FFFFFF', padding: '5%' }}/>
            </div>
            <div className="card-content">
              <h3 className="card-title">Founder & CEO</h3>
              <p className="card-description">
                <span className="company-name">Kable (YC W22)</span>
                <span className="location-date">United States · Sep 2020 - Jul 2023</span>
              </p>
              <p className="card-summary">
                Built usage-based billing infrastructure for API companies. Made lots of mistakes. Learned a lot, and that starting a company is hard.
              </p>
            </div>
          </div>

          <div className="experience-card">
            <div className="card-icon" style={{ backgroundColor: 'transparent' }}>
              <img src="/images/hulu_logo.svg" alt="Hulu" />
            </div>
            <div className="card-content">
              <h3 className="card-title">Lead Software Engineer, Senior Product Manager</h3>
              <p className="card-description">
                <span className="company-name">Hulu</span>
                <span className="location-date">Los Angeles, CA · Jun 2016 - Apr 2021</span>
              </p>
              <p className="card-summary">
                Built Hulu's subscription, billing, and payments platforms. Learned how to shape product strategy and how to scale an organization. 
              </p>
            </div>
          </div>

          <div className="experience-card">
            <div className="card-icon" style={{ backgroundColor: 'transparent' }}>
              <img src="/images/appian_logo.jpg" alt="Appian" />
            </div>
            <div className="card-content">
              <h3 className="card-title">Senior Software Engineer</h3>
              <p className="card-description">
                <span className="company-name">Appian Corporation</span>
                <span className="location-date">Reston, VA · Aug 2014 - May 2016</span>
              </p>
              <p className="card-summary">
                Built business process workflow software for Fortune 500 companies. Learned how to lead an engineering team. 
              </p>
            </div>
          </div>

          <div className="experience-card">
            <div className="card-icon" style={{ backgroundColor: 'transparent' }}>
              <img src="/images/wepay_logo.png" alt="WePay" />
            </div>
            <div className="card-content">
              <h3 className="card-title">Software Engineer</h3>
              <p className="card-description">
                <span className="company-name">WePay</span>
                <span className="location-date">Palo Alto, CA · May 2013 - Aug 2013</span>
              </p>
              <p className="card-summary">
                Built SDKs for WePay's nascent API product. Learned about payments and how to design APIs. 
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">Education</h2>
        
        <div className="experience-grid">
          <div className="experience-card">
            <div className="card-icon">
              <img src="/images/duke_logo.png" alt="Duke" style={{ backgroundColor: '#FFFFFF', padding: '20%' }}/>
            </div>
            <div className="card-content">
              <h3 className="card-title">Duke University</h3>
              <p className="card-description">
                <span className="company-name">Computer Science · Public Policy</span>
                <span className="location-date">Durham, NC · Class of 2014</span>
              </p>
              <p className="card-summary">
                Learned how to code. Had a lot of fun. 
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* <section>
        <h2 className="section-title">Projects</h2>
        <div className="experience-grid">
          <div className="experience-card">
            <div className="card-icon" style={{ backgroundColor: '#333' }}>
              T
            </div>
            <div className="card-content">
              <h3 className="card-title">Totals App</h3>
              <p className="card-description">
                <span className="company-name">Totals</span>
                <span className="location-date">macOS App</span>
              </p>
              <p className="card-summary">
                Totals is a macOS menubar app that tracks real-time revenue from Stripe,
                Gumroad, Paddle, Lemon Squeezy, and Polar.
              </p>
            </div>
          </div>

          <div className="experience-card">
            <div className="card-icon" style={{ backgroundColor: '#6E56CF' }}>
              D
            </div>
            <div className="card-content">
              <h3 className="card-title">Design Buddy</h3>
              <p className="card-description">
                <span className="company-name">Design Buddy</span>
                <span className="location-date">AI Assistant</span>
              </p>
              <p className="card-summary">
                Design Buddy is your AI-powered assistant that reviews designs, guides
                you through improvements, and boosts your design confidence.
              </p>
            </div>
          </div>

          <div className="experience-card">
            <div className="card-icon" style={{ backgroundColor: '#3B82F6' }}>
              U
            </div>
            <div className="card-content">
              <h3 className="card-title">UI Faces</h3>
              <p className="card-description">
                <span className="company-name">UI Faces</span>
                <span className="location-date">Design Resource</span>
              </p>
              <p className="card-summary">
                A growing library of free, AI-generated, high-resolution avatars for
                design mockups, thoughtfully curated to suit all your creative needs.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h2 className="section-title">Companies I Work With</h2>
        <div className="company-grid">
          <div className="company-card">
            <div className="card-icon" style={{ backgroundColor: '#FF0000' }}>
              A
            </div>
            <div className="card-content">
              <h3 className="card-title">Adobe Inc.</h3>
              <p className="card-description">
                <span className="company-name">Adobe Inc.</span>
                <span className="location-date">Plugin development</span>
              </p>
            </div>
          </div>

          <div className="company-card">
            <div className="card-icon" style={{ backgroundColor: '#15C39A' }}>
              G
            </div>
            <div className="card-content">
              <h3 className="card-title">Grammarly Inc.</h3>
              <p className="card-description">
                <span className="company-name">Grammarly Inc.</span>
                <span className="location-date">Product development</span>
              </p>
            </div>
          </div>

          <div className="company-card">
            <div className="card-icon" style={{ backgroundColor: '#111111' }}>
              Y
            </div>
            <div className="card-content">
              <h3 className="card-title">Your Company</h3>
              <p className="card-description">
                <span className="company-name">Your Company</span>
                <span className="location-date">Next collaboration</span>
              </p>
              <p className="card-summary">
                Looking for a product designer who ships? I blend empathy, design craft,
                and technical understanding to deliver user-centered solutions.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      <div className="social-links">
        <div className="social-icons">
          <a href="https://www.linkedin.com/in/adam-d-sommer" target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor"><path d="M14.25 0h-10.5c-2.07 0-3.75 1.68-3.75 3.75v10.5c0 2.07 1.68 3.75 3.75 3.75h10.5c2.07 0 3.75-1.68 3.75-3.75v-10.5c0-2.07-1.68-3.75-3.75-3.75zm-8.25 14.25h-2.25v-8.25h2.25v8.25zm-1.125-9.2c-.72 0-1.31-.59-1.31-1.32s.59-1.32 1.31-1.32 1.31.59 1.31 1.32-.59 1.32-1.31 1.32zm10.125 9.2h-2.25v-4.2c0-2.53-3-2.33-3 0v4.2h-2.25v-8.25h2.25v1.32c1.05-1.94 5.25-2.08 5.25 1.86v5.07z"/></svg>
          </a>
          <a href="mailto:asommer12@gmail.com">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor"><path d="M0 2.25v13.5h18v-13.5h-18zm16.14 1.5l-7.14 5.78-7.14-5.78h14.28zm-14.64 10.5v-8.86l7.5 6.08 7.5-6.08v8.86h-15z"/></svg>
          </a>
          <a href="https://twitter.com/adamdsommer" target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor"><path d="M18 3.42c-.66.29-1.37.49-2.12.58.76-.46 1.35-1.18 1.62-2.04-.71.42-1.5.73-2.34.9-.67-.72-1.63-1.17-2.7-1.17-2.38 0-4.13 2.22-3.6 4.53-3.07-.15-5.79-1.62-7.61-3.86-.97 1.66-.5 3.83 1.14 4.93-.6-.02-1.17-.18-1.67-.46-.04 1.71 1.19 3.31 2.96 3.67-.52.14-1.09.17-1.67.06.47 1.47 1.83 2.53 3.45 2.56-1.55 1.22-3.5 1.76-5.46 1.53 1.63 1.05 3.58 1.66 5.66 1.66 6.86 0 10.73-5.79 10.49-10.98.72-.52 1.35-1.17 1.85-1.91z"/></svg>
          </a>
          <a href="https://instagram.com/adamsommer" target="_blank" rel="noopener noreferrer">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="currentColor"><path d="M9 1.62c2.4 0 2.69.01 3.64.05 2.44.11 3.58 1.27 3.69 3.69.04.95.05 1.23.05 3.64 0 2.4-.01 2.69-.05 3.64-.11 2.42-1.25 3.58-3.69 3.69-.95.04-1.23.05-3.64.05-2.4 0-2.69-.01-3.64-.05-2.44-.11-3.58-1.27-3.69-3.69-.04-.95-.05-1.23-.05-3.64 0-2.4.01-2.69.05-3.64.11-2.42 1.25-3.58 3.69-3.69.95-.04 1.23-.05 3.64-.05zm0-1.62c-2.44 0-2.75.01-3.71.05-3.27.15-5.09 1.96-5.24 5.24-.04.96-.05 1.27-.05 3.71 0 2.44.01 2.75.05 3.71.15 3.27 1.96 5.09 5.24 5.24.96.04 1.27.05 3.71.05 2.44 0 2.75-.01 3.71-.05 3.27-.15 5.09-1.96 5.24-5.24.04-.96.05-1.27.05-3.71 0-2.44-.01-2.75-.05-3.71-.15-3.27-1.96-5.09-5.24-5.24-.96-.04-1.27-.05-3.71-.05zm0 4.38c-2.55 0-4.62 2.07-4.62 4.62s2.07 4.62 4.62 4.62 4.62-2.07 4.62-4.62c0-2.55-2.07-4.62-4.62-4.62zm0 7.62c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm4.8-8.88c-.6 0-1.08.48-1.08 1.08s.48 1.08 1.08 1.08c.6 0 1.08-.48 1.08-1.08s-.48-1.08-1.08-1.08z"/></svg>
          </a>
        </div>
        
        {/* Theme toggle button */}
        <button className="theme-toggle" onClick={toggleTheme} aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}>
          {theme === 'light' ? (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="5"></circle>
              <line x1="12" y1="1" x2="12" y2="3"></line>
              <line x1="12" y1="21" x2="12" y2="23"></line>
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
              <line x1="1" y1="12" x2="3" y2="12"></line>
              <line x1="21" y1="12" x2="23" y2="12"></line>
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
            </svg>
          ) : (
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}

export default App;
